import axios from 'axios';
import store from '../../../store';
import { isTokenExpired } from '@/utils/jwtHelper.js';

const UNAUTHORIZED = 401;

const baseURL = process.env.VUE_APP_BASE_URL

const newAxios = function () {
  return axios.create({
    baseURL: baseURL,
  });
};

export const service = newAxios();
export const socketURL = baseURL;

service.interceptors.request.use(async function (config) {
  const url = config.url || '';
  const isAuthCall = url.includes('auth/refreshToken') || url.includes('auth/login') || url.includes('auth/logout');
  let token = JSON.parse(localStorage.getItem('token'));
  if (token && !isAuthCall && store.getters.getRefreshToken && isTokenExpired(token)) {
    try {
      token = await store.dispatch('refreshToken');
    } catch (e) {
      token = null;
    }
  }
  config.headers.Authorization = token ? `Bearer ${token}` : '';
  return config;
});

service.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    const status = error.response ? error.response.status : null;

    if (status === UNAUTHORIZED && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const newToken = await store.dispatch('refreshToken');
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return service(originalRequest);
      } catch (refreshError) {
        console.error("Recovery refresh failed:", refreshError);
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
)

// TODO find which service this is
// there's no repo that maps out this service
const printServiceURL = process.env.VUE_APP_PRINT_SERVICE_URL || 'http://localhost:8082';

const newPrintAxios = function () {
  return axios.create({
    baseURL: printServiceURL,
  });
};

export const printService = newPrintAxios();

printService.interceptors.request.use(function (config) {
  let token = JSON.parse(localStorage.getItem('token'));
  config.headers.Authorization = token ? `Bearer ${token}` : '';
  return config;
});
